import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Supplier } from "../../interfaces/pharmacy";
import { Edit, Trash2 } from "lucide-react";

interface Handlers {
  onEdit: (supplier: Supplier) => void;
  onDelete: (supplier: Supplier) => void;
}

export const getPharmacySuppliersTableColumns = (
  handlers: Handlers,
): TableColumnsItem[] => [
  {
    key: "name",
    name: "Supplier Name",
    type: ColumnType.TEXT,
    cardTitle: true,
  },
  {
    key: "contactPerson",
    name: "Contact Person",
    type: ColumnType.TEXT,
  },
  {
    key: "phone",
    name: "Phone",
    type: ColumnType.TEXT,
  },
  {
    key: "email",
    name: "Email",
    type: ColumnType.TEXT,
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Edit,
        onPress: (e: React.MouseEvent, row: Supplier) => handlers.onEdit(row),
        tooltip: "Edit",
      },
      {
        type: ButtonType.ICON,
        icon: Trash2,
        onPress: (e: React.MouseEvent, row: Supplier) => handlers.onDelete(row),
        tooltip: "Delete",
      },
    ],
  },
]; 